import Vue from 'vue'
import App from './App.vue'
import router from "./router/router"
import Vant from 'vant';
import { Toast } from 'vant';
import 'vant/lib/index.css';
import 'animate.css';



Vue.config.productionTip = false

Vue.use(Vant);
Vue.use(Toast);
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
